import React from 'react';
export const Newsletter = () => {
  return <section className="py-20 bg-gradient-to-b from-[#0a0a0a] to-red-900/10" data-id="element-170">
      <div className="container mx-auto px-4" data-id="element-171">
        <div className="max-w-4xl mx-auto bg-glass border border-red-600/30 rounded-2xl p-8 sm:p-12" data-id="element-172">
          <div className="text-center mb-8" data-id="element-173">
            <h2 className="text-3xl sm:text-4xl font-bold mb-4" data-id="element-174">
              Stay <span className="text-red-500" data-id="element-175">Connected</span>
            </h2>
            <p className="text-gray-300 max-w-2xl mx-auto" data-id="element-176">
              Join our newsletter to receive updates on new products, special
              offers, and cannabis education.
            </p>
          </div>
          <form className="flex flex-col sm:flex-row gap-4" data-id="element-177">
            <input type="email" placeholder="Enter your email" className="flex-grow bg-black/50 border border-gray-700 focus:border-red-500 text-white rounded-full px-6 py-3 focus:outline-none" required data-id="element-178" />
            <button type="submit" className="bg-red-600 hover:bg-red-700 text-white py-3 px-8 rounded-full transition duration-300" data-id="element-179">
              Subscribe
            </button>
          </form>
          <p className="text-gray-500 text-sm mt-6 text-center" data-id="element-180">
            By subscribing, you agree to receive marketing communications from
            us. You can unsubscribe at any time.
          </p>
        </div>
      </div>
    </section>;
};